import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { arrayConcat3qsij7vh68m69 as arrayConcat } from '../../../../kotlin-kotlin-stdlib/noPackageHacks.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { GCInfoouume21kiwko as GCInfo } from './debugger.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var debug;
function set_counter(_set____db54di) {
  _init_properties_debugger_js_kt__r8r8f0();
  counter = _set____db54di;
}
function get_counter() {
  _init_properties_debugger_js_kt__r8r8f0();
  return counter;
}
var counter;
function get_counterSymbol() {
  _init_properties_debugger_js_kt__r8r8f0();
  return counterSymbol;
}
var counterSymbol;
var WeakReferenceClass;
function WeakReference() {
  if (WeakReferenceClass === VOID) {
    class $ {
      constructor(referred_0) {
        var tmp = this;
        var tmp_0;
        try {
          var tmp_1 = WeakRef(referred);
          tmp_0 = (!(tmp_1 == null) ? !(tmp_1 == null) : false) ? tmp_1 : null;
        } catch ($p) {
          var tmp_2;
          var e = $p;
          tmp_2 = null;
          tmp_0 = tmp_2;
        }
        tmp.hcv_1 = tmp_0;
      }
      pa9() {
        var tmp0_safe_receiver = this.hcv_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.deref();
      }
    }
    initMetadataForClass($, 'WeakReference');
    WeakReferenceClass = $;
  }
  return WeakReferenceClass;
}
var LogRootClass;
function LogRoot() {
  if (LogRootClass === VOID) {
    class $ {
      constructor() {
        LogRoot_instance = this;
        this.ecv_1 = new (PlatformLog())('');
      }
      zbm(tag) {
        return this.ecv_1.zbm(tag);
      }
      fcv(entries) {
        return this.ecv_1.fcv(entries.slice());
      }
      ddo(entries) {
        return this.ecv_1.ddo(entries.slice());
      }
      abn(entries) {
        return this.ecv_1.abn(entries.slice());
      }
      gcv(entries) {
        return this.ecv_1.gcv(entries.slice());
      }
    }
    initMetadataForObject($, 'LogRoot');
    LogRootClass = $;
  }
  return LogRootClass;
}
var LogRoot_instance;
function LogRoot_getInstance() {
  if (LogRoot_instance === VOID)
    new (LogRoot())();
  return LogRoot_instance;
}
function printStackTrace2(_this__u8e3s4) {
  _init_properties_debugger_js_kt__r8r8f0();
  printStackTrace(_this__u8e3s4);
}
var PlatformLogClass;
function PlatformLog() {
  if (PlatformLogClass === VOID) {
    class $ {
      constructor(tag) {
        this.cdo_1 = tag;
      }
      zbm(tag) {
        return new (PlatformLog())(this.cdo_1 === '' ? tag : this.cdo_1 + '/' + tag);
      }
      fcv(entries) {
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, arrayConcat([[this.cdo_1], entries]));
        }.call(this));
      }
      ddo(entries) {
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, arrayConcat([[this.cdo_1], entries]));
        }.call(this));
      }
      abn(entries) {
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.info.apply($externalVarargReceiverTmp, arrayConcat([[this.cdo_1], entries]));
        }.call(this));
      }
      gcv(entries) {
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.warn.apply($externalVarargReceiverTmp, arrayConcat([[this.cdo_1], entries]));
        }.call(this));
      }
    }
    initMetadataForClass($, 'PlatformLog');
    PlatformLogClass = $;
  }
  return PlatformLogClass;
}
function identityHashCode(_this__u8e3s4) {
  _init_properties_debugger_js_kt__r8r8f0();
  if (_this__u8e3s4 == null)
    return 0;
  else {
    // Inline function 'kotlin.js.asDynamic' call
    var e = _this__u8e3s4[get_counterSymbol()];
    if (e != null) {
      return (!(e == null) ? typeof e === 'number' : false) ? e : THROW_CCE();
    }
    var _unary__edvuaz = get_counter();
    set_counter(_unary__edvuaz + 1 | 0);
    var n = _unary__edvuaz;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4[get_counterSymbol()] = n;
    return n;
  }
}
function gc() {
  _init_properties_debugger_js_kt__r8r8f0();
  return new (GCInfo())(-1n);
}
var properties_initialized_debugger_js_kt_4j58na;
function _init_properties_debugger_js_kt__r8r8f0() {
  if (!properties_initialized_debugger_js_kt_4j58na) {
    properties_initialized_debugger_js_kt_4j58na = true;
    debug = true;
    counter = 1;
    counterSymbol = Symbol('IDHC');
  }
}
//region block: exports
export {
  WeakReference as WeakReferencel11chldcck68,
  gc as gczvdtmgupztxq,
  identityHashCode as identityHashCodemue8eqr5m304,
  printStackTrace2 as printStackTrace214c8iyv3cpiv5,
  LogRoot_getInstance as LogRoot_getInstance3817ahbflvs01,
};
//endregion

//# sourceMappingURL=debugger.js.mjs.map
